import React, { useEffect } from 'react';
import { useField, useFormikContext } from 'formik';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';


export const EditNested = (props) => {
  const [field, meta] = useField(props);
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (values.hasSubCategories) {
      setFieldValue('group', 'group');
    } else if (values?.nested?.length > 0) {
      setFieldValue('group', 'nested');
    } else {
      setFieldValue('group', 'normal');
    }
  }, [values.hasSubCategories])

  const disabled = field.value === 'group' || values.hasSubCategories;

  return (
    <TextField
      required
      fullWidth
      select
      variant="outlined"
      label={props.label}
      helperText={meta.touched && meta.error}
      error={meta.touched && !!meta.error}
      disabled={disabled}
      {...field}
      {...props}
    >
      { disabled && <MenuItem value={'group'}>Category</MenuItem> }
      { props.config.categoryHasNestedCategories ? null : <MenuItem value={'normal'}>Category</MenuItem> }
      { props.config.categoryHasNestedCategories ? null : <MenuItem value={'nested'}>Subcategory</MenuItem> }
    </TextField>
  );
};
